import axios from "axios";
import { getCustomerPortalToken, removeCustomerPortalToken } from "./customerPortalAuth.ts";

const isBrowserOnLocalHost = () => {
  if (typeof window === "undefined") {
    return false;
  }

  return ["localhost", "127.0.0.1", "::1"].includes(window.location.hostname);
};

const isLocalApiBase = (baseURL?: string) => {
  if (!baseURL) {
    return false;
  }

  try {
    const parsed = new URL(baseURL, typeof window !== "undefined" ? window.location.origin : "http://localhost");
    return ["localhost", "127.0.0.1", "::1"].includes(parsed.hostname);
  } catch {
    return /^https?:\/\/(localhost|127\.0\.0\.1|\[::1\])/i.test(baseURL);
  }
};

const getBaseURL = () => {
  const configuredBaseURL = process.env.REACT_APP_API_BASE_URL;
  if (configuredBaseURL && (isBrowserOnLocalHost() || !isLocalApiBase(configuredBaseURL))) {
    return configuredBaseURL;
  }

  return process.env.NODE_ENV === "development"
    ? "https://nexus.mbanet.com.pk/api/"
    : "/api/";
};

const customerPortalAxios = axios.create({
  baseURL: getBaseURL(),
  timeout: 30000,
  headers: {
    "Content-Type": "application/json",
  },
});

customerPortalAxios.interceptors.request.use((config) => {
  const token = getCustomerPortalToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

customerPortalAxios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      removeCustomerPortalToken();
    }
    return Promise.reject(error);
  }
);

export default customerPortalAxios;
